import { Box, Container, Grid } from "@mui/material";
import { useEffect } from "react";
import AppBar from "../components/AppBar";
import { useSidebarLayout } from "../zustand/useSidebarStore";
import CardStatistic from "../components/cards/CardStatistic";
import NavBar from "../components/NavBar";
import TableUsers from "../components/tables/TableUsers";
import { useUsuariosStore } from "../zustand/useUsuariosStore";
import DateRangePickerComponent from "../components/inputs/DateRangePicker";
import { useDateRangeStore } from "../zustand/useDateRangeStore";
import CardTopUsers from "../components/cards/CardTop";

export default function UsersRoute() {
  const sidebar = useSidebarLayout();
  const {
    fetchCounts,
    countTotal,
    fetchTopUsuarios,
    topUsuarios,
  } = useUsuariosStore();
  const { fechaInicio, fechaFin, setFechas } = useDateRangeStore();

  // biome-ignore lint/correctness/useExhaustiveDependencies: recargar al cambiar rango de fechas
  useEffect(() => {
    fetchCounts();
    fetchTopUsuarios();
  }, [fetchCounts, fetchTopUsuarios, fechaInicio, fechaFin]);


  return (
    <>
      <AppBar />
      <Container maxWidth={false} sx={{ mt: 1, p: 1, ...sidebar }}>
        <NavBar />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            marginTop: 2,
          }}
        >
          <DateRangePickerComponent
            start={fechaInicio}
            end={fechaFin}
            setDate={setFechas}
            handleChange={() => fetchTopUsuarios()}
          />
          <Grid container spacing={2}>
            <CardStatistic title="Usuarios registrados" count={countTotal}/>

            {topUsuarios.length
              ? topUsuarios.map((usuario, index) => (
                  <CardTopUsers
                    key={usuario.id}
                    title={`${usuario.name} ${usuario.lastName}`}
                    total={usuario.total}
                    packages={usuario.packages}
                    position={index + 1}
                  />
                ))
              : null}
          </Grid>
        </Box>
        <TableUsers />
      </Container>
    </>
  );
}
